import { z } from "zod";

// form zod validation schema
export const createSiteContentSchema = z.object({
  content: z.string().min(1, { message: "This field is required" }),
  title: z.string().trim().min(1, { message: "This field is required" }),
  metaTitle: z.string().optional(),
  metaDescription: z.string().optional(),
  featuredImageId: z.string().uuid().optional(),
  featuredImageUrl: z.string().optional(),
});

// generate form types from zod validation schema
export type CreateSiteContentInput = z.infer<typeof createSiteContentSchema>;
